import { useEffect } from 'react'

import routes from '@/Router/routes.constants'

const useHandle404 = (error, navigate) => {
  useEffect(() => {
    if (error) {
      navigate(routes.notFoundPage)
    }
  }, [error, navigate])
}

export default useHandle404
